<template>
    <base-section header="Svatební dary">
        <v-container fluid grid-list-md>
            <v-layout row wrap grid-list-md justify-center>
                <v-flex class="text-xs-center" xs12>
                    <p><strong>Pokud byste nás chtěli poctít svatebním darem, budeme potěšeni za finanční příspěvek, který bude z praktických důvodů vhodnější než věcné dary.</strong></p>
                    <p>Jestli přecijen toužíte po darování něčeho hmatatelného, vybírejte prosím z níže uvedeného seznamu, který budeme postupně doplňovat.</p>
                    <p>Vybraný dar prosím nejprve <strong>rezervujte</strong> na na e-mailu <strong>sternwaldovaadela@gmail.com</strong> (ségra Anett)</p>
                    <p><strong>Děkujeme</strong></p>
                </v-flex>
                <v-flex sm6 md4 lg3 fill-height v-for="gift in gifts" :key="gift.title">
                    <wedding-gift v-bind="gift"/>
                </v-flex>
            </v-layout>
        </v-container>
    </base-section>
</template>

<script>
    import BaseSection from "@/components/BaseSection";
    import WeddingGift from "@/components/WeddingGift";
    import api from "@/api";

    export default {
        name: "SectionGifts",
        components: {WeddingGift, BaseSection},
        data() {
            return {
                gifts: []
            }
        },
        async mounted() {
            this.gifts = await api.fetchGifts();
        }
    };
</script>